module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAABCAYAAAC2YQwdAAAAD0lEQVQImWM4c+bM/8GEAX8jee3FUmO9AAAAAElFTkSuQmCC"